import {axios} from "@/api"

const state = {
  file: '',
  urlLocal: '',
  urlTypeLocal: '',
  sendUrl: '/services/admin/v1/contractors/${id}/generateUploadLink'
};

// getters
/* eslint-disable no-shadow */
const getters = {}

// actions
const actions = {
  async sendFile ({state}) {
    if (!state.file) return
    try {
      const { data } = await axios.post(`${process.env.VUE_APP_API}${state.sendUrl}`)
      let config = {
        method: 'put',
        url: data.uploadUrl,
        data : state.file.file
      };
      await axios(config)
      this.file = ''
    } catch (e) {
      console.error(e)
      this.mix__openNotification('Ошибка', 'на сервере', 'error')
    }
  }
}

// mutations
/* eslint-disable no-shadow */
const mutations = {
  clearFile (state) {
    state.file = ''
    state.urlLocal = ''
    state.urlTypeLocal = ''
  },
  setFile (state, file) {
    state.file = file
  },
  setUrl (state, url) {
    state.sendUrl = url
  },
  setUrlLocal (state, url) {
    state.urlLocal = url
  },
  setTypeLocal (state, type) {
    state.urlTypeLocal = type
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
